import type { ExportUsageToMarketplaceRequestPayload } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function useExportUsageToMarketplace(
  options?: UseMutationOptions<void, unknown, ExportUsageToMarketplaceRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (exportUsageToMarketplaceRequest) => {
      const api = getPrivateApi();

      return api.exportUsageToMarketplace({
        exportUsageToMarketplaceRequest,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.jobs());
    },
    ...options,
  });
}
